// Libs
import { Navigate, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
// Protected Routes
import ProtectedRoute from "./Protected Routes/login";
// Pages
import LoginPage from "./Pages/LoginPage";
import DashboardPage from "./Pages/DashboardPage";
import Dashboard from "./Components/Dashboard";
import PreAuth from "./Components/PreAuth";
import StatusCheck from "./Components/StatusCheck";
import UpdateClaim from "./Components/UpdateClaim";
import UpdateUserProfile from "./Components/Profile/UpdateUserProfile";
import Payers from "./Components/Payers";
// Css
import "./App.css";

function App() {
  // Constants
  const queryClient = new QueryClient();
  return (
    <>
      <div className="app">
        <Toaster position="top-right" />
        <QueryClientProvider client={queryClient}>
          <div>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<LoginPage />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<DashboardPage />}>
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="preAuthorization" element={<PreAuth />} />
                  <Route path="statusCheck" element={<StatusCheck />} />
                  <Route path="updateClaim" element={<UpdateClaim />} />
                  <Route path="payers" element={<Payers />} />
                  <Route path="profile">
                    <Route
                      path="updateUserProfile"
                      element={<UpdateUserProfile />}
                    />
                  </Route>
                  <Route path="*" element={<Dashboard />} />
                </Route>
              </Route>
            </Routes>
          </div>
        </QueryClientProvider>
      </div>
    </>
  );
}

export default App;
